import { ModuleWithProviders, NgModule } from '@angular/core';

import { JsonDateConfig, JsonDateInjectConfig } from './json-date.config';
import { jsonDateInterceptorFn } from './json-date.interceptor';
import { JsonDateService } from './json-date.service';

@NgModule({})
export class JsonDateModule {
  public static configure(
    config: JsonDateConfig,
  ): ModuleWithProviders<JsonDateModule> {
    return {
      ngModule: JsonDateModule,
      providers: [
        { provide: JsonDateInjectConfig, useValue: config },
        JsonDateService,
      ],
    };
  }
}

export { JsonDateService, jsonDateInterceptorFn };
